import { Routes, Route } from 'react-router-dom';
import { lazy } from 'react';
import { LazyLoadComponent } from '@src/components/LazyLoadComponent/LazyLoadComponent';

const SubAccountsList = lazy(() =>
    import('../../pages/SubAccount').then((module) => ({
        default: module.SubAccountList,
    }))
);

const SubAccountDetails = lazy(() =>
    import('../../pages/SubAccount').then((module) => ({
        default: module.SubAccountDetails,
    }))
);

export function SubAccountsContainer() {
    return (
        <Routes>
            <Route
                path={'*'}
                element={
                    <LazyLoadComponent
                        type="LIST"
                        Component={<SubAccountsList />}
                    />
                }
            />
            <Route
                path={'details/:id'}
                element={
                    <LazyLoadComponent
                        type="PAGE"
                        Component={<SubAccountDetails />}
                    />
                }
            />
        </Routes>
    );
}
